//* import components
import Loading from "./components/Loading/Loading";
import { useContext } from "react";
import { AuthContext } from "./store/auth-context";
import Tours from "./components/Tours/Tours";
//* import styles
import "./App.css";

const App = () => {
  const appCtx = useContext(AuthContext);
 
  return (
    <section className="container">
      {appCtx.isLoading && <Loading />}
      {!appCtx.isLoading &&
        appCtx.error.hasError && (
          <h1 className="error">
            {appCtx.error.errorName}
          </h1>
        )}
      {!appCtx.isLoading && !appCtx.hasError && (
        <Tours
        />
      )}
    </section>
  );
};

export default App;
